import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

// at the start of each encounter, show their killing intent
// ai prefers killing neutral vs bad.
// win condition to go x turns without a death, get all to put weapons down
// support skills that work on enemies.

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "g4",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": function(stage) {
            const remainingUnits = Object.values(stage.units).filter((unit) => {
                return unit.affiliation != "good"
                    && unit.type != "spot"
                    && unit.state != "pacified"
                    && unit.hasBeenRemoved != true && unit.isDead != true
                    && Zone.isInBounds(stage.encounters[stage.currentEncounterKey].zone, unit.position)
            })
            return "Pacify " + remainingUnits.length + " units"
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript(),
                ]
            },
            ...PlotScripts.EncounterVictories({"encounterKeys": [1, 2, 3, 4], "nextURL": "/games/war"}),
            PlotScripts.ChapterFailure(),
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.units["priestess"].isDead == true
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    {"func": () => App.game.chapter.restart()},
                ]
            },
        ]
    },
}
